import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./PlayoutPlayer.css";
import { FaPlay, FaPause } from 'react-icons/fa';
import { useTranslation } from "react-i18next";


function convertTimeToSeconds(time) {
   const [hours, minutes, seconds] = time.split(':').map(Number);
   return hours * 3600 + minutes * 60 + seconds;
}

export const PlayoutJs = ({ options, onReady, isLive }) => {
   const { t } = useTranslation();
   const navigate = useNavigate();
   const user_role = localStorage.getItem("role");
   const user_id = localStorage.getItem("user_id");
   const [isPlaying, setIsPlaying] = useState(false);
   const [isFullscreen, setIsFullscreen] = useState(false);
   const [buffering, setBuffering] = useState(false);
   const [currentTime, setCurrentTime] = useState(0);
   const [playedSeconds, setPlayedSeconds] = useState(0);
   const [duration, setDuration] = useState(0);
   const [watchPercentage, setWatchPercentage] = useState(0);
   const [progress, setProgress] = useState(0);
   const [loading, setLoading] = useState(false);
   const [loadingAlertShown, setLoadingAlertShown] = useState(false);
   const [isProcessing, setIsProcessing] = useState(false);
   const [title, setTitle] = useState("");
   const [showEpg, setShowEpg] = useState(false); 

   const videoRef = useRef(null);
   const playerRef = useRef(null);

   const TimeConverter = (data) => {
      const [hours, minutes, seconds] = data?.split(":").map(Number);
      const totalSeconds = hours * 3600 + minutes * 60 + seconds;
      return totalSeconds;
   }

   const togglePlayPause = () => {
      const player = playerRef.current;
      console.log("playerrr",player);
      if (player) {
         if (player.paused()) {
            setTimeout(() => {
               player.play().catch((error) => {
                  console.error('Error playing video:', error);
               });
            }, 100); // 100ms delay
         } else {
            player.pause();
         }
      }   
   };

   const handleFullscreen = () => {
      const player = playerRef.current;
      if (player) {
         if (player.isFullscreen()) {
            player.exitFullscreen();
         } else {
            player.requestFullscreen();
         }
      }
   };

   useEffect(() => {
      let player;
      const initPlayer = async () => {
         if (videoRef.current) {
            // Dynamically import video.js and its CSS
            const [videojsModule] = await Promise.all([
               import('video.js'),
               import('video.js/dist/video-js.css')
            ]);
            const vjs = videojsModule.default || videojsModule;

            // Re-verify videoRef.current is still available after the await
            if (!videoRef.current) return;

            player = vjs(videoRef.current, options, () => {
               playerRef.current = player;

               player.loadingSpinner.removeClass('vjs-loading-spinner');
               player.loadingSpinner.addClass('vjs-loading-spinner-myvideo');

               const handleContextMenu = (e) => {
                  e.preventDefault();
               };
               videoRef.current.addEventListener('contextmenu', handleContextMenu);

               onReady && onReady(player);

               setTimeout(() => {
                  document.querySelectorAll('.vjs-live-control').forEach(liveControl => {
                     if (!liveControl.closest('.vjs-control-bar')) {
                        liveControl.remove();
                     }
                  });
               }, 500);

               const playProgress = document.querySelector('.vjs-play-progress.vjs-slider-bar');
               if (playProgress) {
                  playProgress.classList.add('vjs-progress-end');
               }

               player.on('fullscreenchange', () => setIsFullscreen(player.isFullscreen()));
               player.on('play', () => setIsPlaying(true));
               player.on('pause', () => setIsPlaying(false));
            });
         }
      };

      initPlayer();

      return () => {
         if (player) {
            player.dispose();
            playerRef.current = null;
         }
      };
   }, [options]);

   return (
      <>
         <div>
            <div data-vjs-player className="position-relative" style={{ overflow: "hidden" }}>
               <div className="d-flex align-items-center position-relative gap-3">
               <div className="d-flex ms-1 vjs-live-display-playout">
                     {isLive && <span className="live_dot mt-2">•</span>}
                  </div>
               </div>
               {/* <button className="custom-play-pause-button bg-transparent" onClick={togglePlayPause} >
                  {isPlaying ? <FaPause style={{ fontSize: "35px" }} /> : <FaPlay style={{ fontSize: "35px" }} />}
               </button> */}

               <video data-vjs-player ref={videoRef} className="vjs-big-play-centered vjs-theme-city my-video-dimensions video-js vjs-play-control" />

            </div>
         </div>
      </>
   );
};

export default PlayoutJs;